/* @flow */
import { actionsPreprocessor } from '@/utils/redux';

const actionNames = [
  'TOGGLE_UAPI_IFRAME_MODAL',
  'TOGGLE_INVITE_USER_MODAL',
  'TOGGLE_EDIT_PROPOSALS_TABLE_MODAL',
  'TOGGLE_PROPOSALS_FORM_MODAL',
  'TOGGLE_UPLOAD_RESOURCE_MODAL',
  'TOGGLE_GENERATE_PROPOSAL_MODAL',
  'TOGGLE_VIEW_PROPOSAL_INPUTS_MODAL',
  'TOGGLE_UPLOAD_BULK_ENRICHMENT_FILE_MODAL',
  'TOGGLE_UPLOAD_PROSPECT_BULK_ENRICHMENT_FILE_MODAL',
  'TOGGLE_PRIVACY_POLICY_MODAL',
  'TOGGLE_TERMS_OF_SERVICE_MODAL',
  'TOGGLE_PLATFORM_AGREEMENTS_MODAL',
  'TOGGLE_QUOTES_MODAL',
];

const { actions, actionTypes } = actionsPreprocessor('modals', actionNames);

export default actions;
export { actionTypes };
